import type { ReactNode } from 'react';

export interface StatusScreenProps {
  /** Short kicker above the headline, e.g. «404» or «Доступ ограничен». */
  kicker?: string;
  title: string;
  description?: string;
  /** Optional call to action — a retry button, a link back to the workspace. */
  action?: ReactNode;
  /** Announce to assistive technology as an alert rather than a status. */
  tone?: 'status' | 'alert';
}

/**
 * Full-height message panel shared by the shell's loading, error, forbidden and
 * not-found states. Purely presentational — it owns no routing or auth logic.
 */
export default function StatusScreen({
  kicker,
  title,
  description,
  action,
  tone = 'status',
}: StatusScreenProps) {
  return (
    <div className="status-screen" role={tone} aria-live={tone === 'alert' ? 'assertive' : 'polite'}>
      <div className="status-screen__panel">
        {kicker ? <p className="status-screen__kicker">{kicker}</p> : null}
        <h1 className="status-screen__title">{title}</h1>
        {description ? <p className="status-screen__description">{description}</p> : null}
        {action ? <div className="status-screen__action">{action}</div> : null}
      </div>
    </div>
  );
}
